module.exports = __webpack_public_path__ + "b09134ac350e6345b0b6cd94f78f6ffc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lalezar-Font/TTF/Lalezar-Regular.ttf
// module id = 488
// module chunks = 0